import { OpportunityAddress } from '@features/opportunities/modules/core/models/address';
import { OpportunitySchema } from '@features/opportunities/modules/core/models/schema-property-definition';
import { OpportunitySchemaUtil } from '@features/opportunities/modules/core/utils/opportunity-schema-util';
import { Address } from '@liberty-financial/agp-shared';
import { SparkAddress } from '@shared/models/address';
import { IdObjectValue } from '@shared/models/schema-property-definition';

import * as _ from 'lodash';

export namespace Residence {
  export interface SchemaPropertyDefinition {
    address: OpportunityAddress.SchemaPropertyDefinition;
    addressType: OpportunitySchema.OptionsPropertyDefinition;
    startDate: OpportunitySchema.StringPropertyDefinition;
    endDate: OpportunitySchema.StringPropertyDefinition;
    residentialStatus: OpportunitySchema.OptionsPropertyDefinition;
  }

  export interface SchemaContract {
    address?: SparkAddress.SchemaContract | null;
    addressType?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    residentialStatus?: string | null;
  }

  export interface Model extends IdObjectValue.Crud.Updatable {
    address: Address | null;
    addressType: string | null;
    startDate: string | null;
    endDate: string | null;
    residentialStatus: string | null;
  }

  export function toModel(
    contract: SchemaContract & IdObjectValue.Crud.Updatable
  ): Model {
    return {
      id: contract.id,
      created: contract.created,
      deleted: contract.deleted,
      address: contract.address ? SparkAddress.toModel(contract.address) : null,
      addressType: contract.addressType ?? null,
      startDate: contract.startDate ?? null,
      endDate: contract.endDate ?? null,
      residentialStatus: contract.residentialStatus ?? null
    };
  }

  export function toSchemaContract(
    model: Partial<Model>
  ): Partial<SchemaContract> {
    return {
      ...model,
      address: model.address
        ? SparkAddress.toSchemaContract(model.address)
        : undefined,
      startDate: OpportunitySchemaUtil.Transform.Date.toSchemaContract(
        model.startDate
      ),
      endDate: OpportunitySchemaUtil.Transform.Date.toSchemaContract(
        model.endDate
      )
    };
  }

  export namespace Collection {
    export type SchemaContract =
      IdObjectValue.Crud.IdObjectValueSchemaCollection<Residence.SchemaContract>;
    export type Model = Residence.Model[];

    export function toModel(c: SchemaContract): Model {
      return IdObjectValue.Crud.toNativeArray(c, Residence.toModel);
    }

    export function toSchemaContract(m: Model): SchemaContract {
      return IdObjectValue.Crud.toIdObjectValueSchemaCollection(
        m,
        Residence.toSchemaContract
      );
    }
  }
}
